// @ts-nocheck
import * as exVideo from '../../media/video';

// ----------------------------------------------------------------------------

function create(canvas, config = {}): any {
    // If there is no element canvas
    if (!(canvas instanceof HTMLCanvasElement)) {
        console.error('Is not an element canvas...');
        return;
    }

    // ------------------------------------------------------------------------

    // Get context 2d
    const context = canvas.getContext('2d');

    // If using element video
    let elVideo = config.video;
    // If there is no element video, create
    if (!(config.video instanceof HTMLVideoElement)) {
        // Create element (video)
        elVideo = exVideo.create({
            merge: config,
        });
    }

    // Create event (play)
    elVideo.addEventListener('play', function (): any {
        // Update
        requestAnimationFrame(fnFrame);
    });

    // Create event (loaded data)
    elVideo.addEventListener('loadeddata', function (evt): any {
        // Update
        requestAnimationFrame(fnFrame);

        // If using function loaded data
        if (typeof config.fnLoadedData === 'function') {
            config.fnLoadedData.call(this, evt);
        }
    });

    // Function Frame
    const fnFrame = function (): any {
        context.fillStyle = 'black';
        context.clearRect(0, 0, canvas.width, canvas.height);

        // If the video is not ready
        if (elVideo.readyState == 0) {
            return;
        }

        // Dimension
        const scale = Math.min(canvas.width / elVideo.videoWidth, canvas.height / elVideo.videoHeight);
        const height = elVideo.videoHeight;
        const width = elVideo.videoWidth;
        const y = canvas.height / 2 - (height / 2) * scale;
        const x = canvas.width / 2 - (width / 2) * scale;

        // Draw Image
        context.drawImage(elVideo, x, y, width * scale, height * scale);

        // If the video paused or ended
        if (elVideo.paused || elVideo.ended) {
            drawPlayIcon(canvas);
            return;
        }

        // Update
        requestAnimationFrame(fnFrame);
    };

    // If using play
    if (config.play === true) {
        // Create element (click)
        canvas.addEventListener('click', function (): any {
            // If the video is not ready
            if (elVideo.readyState == 0) {
                return;
            }

            // If the video paused or ended
            if (elVideo.paused || elVideo.ended) {
                elVideo.play();
            }
            // If the video played
            else {
                elVideo.pause();
            }
        });

        // Create element (play)
        elVideo.addEventListener('play', function (): any {
            fnFrame();
        });
    }

    // Return
    return elVideo;
}

function player(canvas, video): any {
    let context;

    // Function Frame
    const fnFrame = function (): any {
        context.fillStyle = 'black';
        context.clearRect(0, 0, canvas.width, canvas.height);

        // If the video is not ready
        if (video.readyState == 0) {
            return;
        }

        // Dimension
        const scale = Math.min(canvas.width / video.videoWidth, canvas.height / video.videoHeight);
        const height = video.videoHeight;
        const width = video.videoWidth;
        const y = canvas.height / 2 - (height / 2) * scale;
        const x = canvas.width / 2 - (width / 2) * scale;

        // Draw Image
        context.drawImage(video, x, y, width * scale, height * scale);

        // If the video paused or ended
        if (video.paused || video.ended) {
            return;
        }

        // Update
        requestAnimationFrame(fnFrame);
    };

    // Create element (play)
    video.addEventListener('play', function (): any {
        fnFrame();
    });
}

// ----------------------------------------------------------------------------

function drawPlayIcon(canvas): any {
    // Get context 2d
    const context = canvas.getContext('2d');

    context.fillStyle = 'black'; // darken display
    context.globalAlpha = 0.5;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#DDD'; // colour of play icon
    context.globalAlpha = 0.75; // partly transparent

    context.beginPath(); // create the path for the icon
    const size = (canvas.height / 2) * 0.3; // the size of the icon
    context.moveTo(canvas.width / 2 + size / 2, canvas.height / 2); // start at the pointy end
    context.lineTo(canvas.width / 2 - size / 2, canvas.height / 2.1 + size);
    context.lineTo(canvas.width / 2 - size / 2, canvas.height / 1.9 - size);
    context.closePath();

    context.fill();
    context.globalAlpha = 1; // restore alpha
}

// ----------------------------------------------------------------------------

const controller = {
    player,
};

export { controller, create, drawPlayIcon, player };
